// extracted by mini-css-extract-plugin
export default {"success":"Result_success__kU6LU","failure":"Result_failure__Vz3qv","hash":"Result_hash__VvCwW","feedback":"Result_feedback__1cwvj"};